const autoNgTemplateLoaderTemplate1 = require('./constraint.html');

angular.module('portainer.kubernetes').component('kubernetesSecurityConstraintController', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesSecurityConstraintController',
});
